import type { JobPostFilters } from "../../types";

const publicBase = ["job-posts"] as const;

export const publicJobPostQueryKeys = {
  all: publicBase,
  list: (filters: JobPostFilters) =>
    [
      ...publicBase,
      "list",
      {
        startDate: filters.startDate?.toISOString(),
        endDate: filters.endDate?.toISOString(),
        statuses: filters.statuses?.join(","),
        city: filters.city,
        compensation: filters.compensation?.toString(),
        locationType: filters.locationType?.toString(),
        jobPostId: filters.jobPostId,
        page: filters.page?.toString(),
        subdvisions: filters?.subdivisionCodes?.join(","),
      },
    ] as const,

  detail: (jobPostId?: string) => [...publicBase, jobPostId],
};
